$(function () {
    var widthMobile = 992;
    var $navi = $('.global_header .logo_line');
    var isAuthor = false;
    var isStaffPortalHeader = false;
    if($(".author").length) {
    	isAuthor = true;
    }
    if($(".sub_site_header").length) {
        isStaffPortalHeader = true;
    }
    var body_sub_page = $('.body_sub_page');
    $(window).scroll(function () {
        if ($(window).width() > widthMobile) {
            var y = $(this).scrollTop(),
                speed = 0.003,
                percent = Math.round((y * speed) * 100) / 100;
            if(isStaffPortalHeader) {
                percent = y / 100;
            }

            if (percent >= 1) {
                percent = 1;
            }
            else if (percent < 0) {
                percent = 0;
            }
    
            // APPLY STYLING
            // Only on flinders main site.
            if (!isStaffPortalHeader) {
                $navi.css({
                    'background-color': 'rgba(255, 211,0,' + percent + ')'
                });
                var global_header_top = $('.header_site').offset().top;
                if (percent <= 0) {
                    global_header_top = global_header_top + 25;
                }
                $('.global_header').css("top", "calc( "+global_header_top + "px * 1 / var(--recite-me-zoom) )");
            }

    
            // YELLOW HEADER
            if (percent >= 1) {

                if(isStaffPortalHeader) {
                    body_sub_page.addClass('sectionfixed');
                } else {
                    $navi.addClass('yellow_header');
                }
                /*appeared  "Back to top" icon*/
                $('.js-scroll-top').show();    
            } else {

                if(isStaffPortalHeader) {
                    body_sub_page.removeClass('sectionfixed');
                } else {
                    $navi.removeClass('yellow_header');
                }
                /*removed  "Back to top" icon*/
                $('.js-scroll-top').hide();
            }

            var headerOffsetTop = $(this).getHeaderTopOffset();

            if (y > headerOffsetTop) { // should add when top is greater than 0
                if(!isStaffPortalHeader && !isAuthor && y > 0) {
                    body_sub_page.addClass('sectionfixed');
                }
                // Code to fix the redundant double hover over items while scrolling - clone header issue...
                $('body .pull-right:first ul li').removeClass('open_row');
            }
            else {
                if(!isStaffPortalHeader) {
                    body_sub_page.removeClass('sectionfixed');
                }
                $('.logo_line').removeClass('header_active').removeClass('search_transorm_dark_bg');
                $('.home_header_line').removeClass('header_active');
                $('.header_search_top').removeClass('active');
                $('.header_global_search_form').fadeOut('500');
                // Code to fix the redundant double hover over items while scrolling - clone header issue...
                $('body .pull-right:last ul li').removeClass('open_row');
            }
        } else {
            const reciteMeHeader = document.getElementById("recite-header");
            const reciteMeHeight = reciteMeHeader ? reciteMeHeader.offsetHeight : 0;
            if(reciteMeHeight){
                $('.global_header').css("top", "calc("+ reciteMeHeight + 'px * 1 / var(--recite-me-zoom) ) ');
            } else {
                $('.global_header').css("top", '');
            }
        }
    });
    $(window).scroll();
});
